import {
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { backendErrorsHandler } from '../../utils/Notification/BackendErrorsHandler';
import { deleteOutsourcedOrderById, updateOutsourcedOrderById } from '../../services/outsourcingOrder.service';

const listQueryKey = 'outsourcingOrders';
export const useUpdateOutsourcedOrderById = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (data: {
      id: string,
      partner?: string,
      outsourcedStatus?: "pending" | "in_process" | "returned",
      sentDate?: string,
      receivedDate?: string,
      externalOrderId?: string,
    }) => {
      try {
        const { id, ...rest } = data;
        const res = await updateOutsourcedOrderById(id, rest);
        if (!res?.data) {
          throw new Error('Oh no! Something went wrong while updating.');
        }
        return res.data;
      } catch (e: any) {
        console.log('error caught', e['response']?.data?.['errors']);
        backendErrorsHandler(e);
        throw e;
      }
    },
    onSuccess: async () => {
      //INVALIDATE CACHED STAFF WITH STORE ID
      return Promise.all([queryClient.invalidateQueries({
        queryKey: [listQueryKey],
      })]);
    }
  });
};

export const useDeleteOutsourcedOrderById = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (id: string) => {
      try {
        const res = await deleteOutsourcedOrderById(id);
        if (!res?.data?.data) {
          throw new Error('Oh no! Something went wrong while fetching.');
        }
        return res.data.data;
      } catch (e: any) {
        console.log('error caught', e['response']?.data?.['errors']);
        backendErrorsHandler(e);
        throw e;
      }
    },
    onSuccess: async () => {
      return Promise.all([queryClient.invalidateQueries({
        queryKey: [listQueryKey],
      })]);
    }
  });
};